import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Oscar Health",
  shortName: "Oscar",
  slug: "oscar-insurance",
  seoTitle: "Oscar Health TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Oscar Health insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Oscar plan in Coral Springs, FL.",
  seoKeywords:
    "Oscar Health TMS coverage, Oscar TMS therapy, Oscar depression treatment Florida, Oscar mental health benefits Coral Springs FL, Oscar SAINT TMS",
  planType:
    "technology-focused health insurance provider (Marketplace & employer plans)",
  planRegion: "Florida, Texas, California, and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Oscar Health is a technology-focused health insurance company offering individual marketplace plans, employer-sponsored coverage, and Medicare Advantage. Oscar plans include behavioral health benefits as part of their essential health benefits coverage, which may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Oscar offers different metal tiers and network types, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.hioscar.com/",
  officialResourceLabel: "Oscar Health official website",
};

export const OscarInsurance = () => <InsurancePageTemplate config={config} />;
export default OscarInsurance;
